/*
 *
 * PerformRegularSecurityTests languageModule
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import PortalTextLink from '@nexidigital/portaltextlink'
import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  modalTitle: <PortalMessage id='t.app.pci.performSecurityTests.modalTitle' defaultMessage='Esegui regolarmente test di sicurezza' />,
  protectionLabel: <PortalMessage id='t.app.pci.performSecurityTests.protectionLabel' defaultMessage='Protezione' />,
  protectionValue: <PortalMessage id='t.app.pci.performSecurityTests.protectionValue' defaultMessage='Alta' />,
  difficultyLabel: <PortalMessage id='t.app.pci.performSecurityTests.difficultyLabel' defaultMessage='Difficoltà' />,
  difficultyValue: <PortalMessage id='t.app.pci.performSecurityTests.difficultyValue' defaultMessage='Alta' />,
  validForLabel: <PortalMessage id='t.app.pci.performSecurityTests.validForLabel' defaultMessage='Valido per vendite tramite:' />,
  ecommerceLabel: <PortalMessage id='t.app.pci.performSecurityTests.ecommerceLabel' defaultMessage='E-commerce' />,
  introText: <PortalMessage id='t.app.pci.performSecurityTests.introText' defaultMessage='Ogni giorno vengono scoperti nuovi <b>punti vulnerabili nei sistemi informatici</b> e nelle applicazioni. I malintenzionati sfruttano queste vulnerabilità per <b>lanciare i loro attacchi</b>. Pertanto, è fondamentale effettuare dei test per identificare la presenza di vulnerabilità nelle tue reti, in modo da poterle correggere nel minor tempo possibile.' />,
  advise1Title: <PortalMessage id='t.app.pci.performSecurityTests.advise1.title' defaultMessage='INFORMATI' />,
  advise1Text: (
    <PortalMessage
      id='t.app.pci.performSecurityTests.advise1.text'
      defaultMessage='Chiedi al tuo fornitore o alla tua banca se hanno a disposizione delle agevolazioni con uno dei <b>fornitori di servizi di test delle reti </b> (ASV - Approved Scanning Vendors) <b>approvati dal Council PCI</b>. Al seguente {link} puoi trovare la lista aggiornata di tutti gli ASV attualmente approvati dal PCI Security Standards Council.'
      values={{
        link: (
          <PortalTextLink
            href='https://www.pcisecuritystandards.org/assessors_and_solutions/approved_scanning_vendors/'
            label='link'
            underline='always'
            isTargetBlank
          />
        )
      }}
    />
  ),
  provider1Name: <PortalMessage id='t.app.pci.performSecurityTests.provider1.name' defaultMessage='Mediaservice.net S.R.L.' />,
  provider2Name: <PortalMessage id='t.app.pci.performSecurityTests.provider2.name' defaultMessage='Kima Projects Services' />,
  websiteLabel: <PortalMessage id='t.app.pci.performSecurityTests.websiteLabel' defaultMessage='sito' />,
  emailLabel: <PortalMessage id='t.app.pci.performSecurityTests.emailLabel' defaultMessage='email' />,
  advise2Title: <PortalMessage id='t.app.pci.performSecurityTests.advise2.title' defaultMessage='CONTATTA UN APPROVED SCANNING VENDOR' />,
  advise2Text: <PortalMessage id='t.app.pci.performSecurityTests.advise2.text' defaultMessage="Rivolgiti ai <b>fornitori di servizi di test</b> delle reti per effettuare una <b>scansione completa</b> dei tuoi sistemi informatici. Gli strumenti e le applicazioni utilizzate sono predisposte per evidenziare <b>eventuali vulnerabilità</b>, producendo un report con l'elenco dettagliato delle <b>attività prioritarie da eseguire</b>." />,
  advise3Title: <PortalMessage id='t.app.pci.performSecurityTests.advise3.title' defaultMessage='PRENDI I PROVVEDIMENTI NECESSARI' />,
  advise3Text: <PortalMessage id='t.app.pci.performSecurityTests.advise3.text' defaultMessage='Chiedi consiglio al fornitore ASV per <b>risolvere le vulnerabilità</b> evidenziate dalle scansioni, a seconda della loro criticità.' />
}

export default formattedMessage
